import CheckBox from "./CheckBox/Checkbox";
import DateTimePicker from "./DatePicker/DateTimePicker";
import DatePicker from "./DatePicker/DatePicker";
import InputForm from "./InputForm/InputForm";
import DataTable from "./DataTable/DataTable";
import UploadImg from "./UploadImg/UploadImg";

export { CheckBox, DateTimePicker, InputForm, DatePicker,DataTable,UploadImg };
